
<div>
  <label :for="`${fieldName}-type`" class="a-select-label">
    {{dateRangeDisplay}}
    <slot name="label"></slot>
  </label>
  <row>
    <column>
      <a-select
        v-model="datetimeType"
        :options="typeOptions"
        :id="`${fieldName}-type`"
        compress
        :disabled="disabled"
      ></a-select>
    </column>
    <suffix v-if="datetimeType === DatetimeType.Formula">
      <button class="btn-icon grey-to-blue formula" @click.self="editFormula" :disabled="disabled">
        <span class="florin icon"></span>
        <span class="sr-only">{{displayName}} {{modeString}} Formula Button</span>
      </button>
    </suffix>
  </row>
  <date-picker
    v-if="datetimeType === DatetimeType.Custom"
    :key="fieldName"
    :mode="datetimeMode"
    v-model="parent[fieldName]"
    :disabled="disabled || datetimeType !== DatetimeType.Custom"
    v-bind="datePickerProps"
  ></date-picker>
  <template v-else-if="datetimeType === DatetimeType.Formula">
    Formula: {{formulaText}}
  </template>

  <formula-modal
    v-if="editedFormula"
    :dynamic-options="dynamicOptions"
    :formula="editedFormula"
    :state="modalStateFor(vueModalID.formulaEditor)"
    :index="vueModalID.formulaEditor"
    @toggle-modal="hideFormulaModal"
    @saved="(eventData) => $emit('saved', eventData)"
  ></formula-modal>
</div>
